export default __webpack_public_path__ + "static/raven-4-b-e01c4bc75f6512d723905976ff5bcce3.webp";